import {
  SOCKET_CONNECT,
  SOCKET_DISCONNECT,
  SOCKET_RECONNECTING,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_FAILED,
} from '../actions/socket-io';

const initialState = {
  connected: false,
  connecting: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SOCKET_CONNECT:
      return { ...state, connected: true, connecting: false };
    case SOCKET_DISCONNECT:
      return { ...state, connected: false, connecting: false };
    case SOCKET_RECONNECTING:
      return { ...state, connected: false, connecting: true };
    case SOCKET_RECONNECT:
      return { ...state, connected: true, connecting: false };
    case SOCKET_RECONNECT_FAILED:
      return { ...state, connected: false, connecting: false };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/socket-io.js